import img1 from '../images/svg/icon-1.svg'
import img2 from '../images/svg/icon-2.svg'
import img3 from '../images/svg/icon-3.svg'
import img4 from '../images/svg/icon-4.svg'

const dataPortfolio = [

    {
        id: 1,
        img: img1,
        title: 'Follow Us Online',
        desc: 'Tap in on IG and TikTok — @nxtlvlnights. You’ll see the vibes before you even pull up.'
    },
    {
        id: 2,
        img: img2,
        title: 'RSVP for the Next Event',
        desc: 'Lock in your spot. We keep it exclusive, so if your name’s not down, you’re not walking in.'
    },
    {
        id: 3,
        img: img3,
        title: 'Show Up & Show Out',
        desc: 'No wallflowers here. Come fresh, bring energy, and get ready to level up your nightlife game.'
    },
    {
        id: 4,
        img: img4,
        title: 'Become a Regular',
        desc: 'When you’re NXTLVL, you don’t just attend — you belong. Join the fam and ride with us weekly.'
    },

]

export default dataPortfolio;